
console.log("contents", process.env.REACT_APP_MEDINEER_CONTENTCURATORIDS)
export const configUrl = {
    AssessmentServer: process.env.REACT_APP_Assessment,
    PredictorServer: process.env.REACT_APP_PREDICTOR_SERVER,
    MediNeerProviderId: Number(process.env.REACT_APP_MEDINEERPROVIDERID),   //need to change as per medineer account providerId
    MediNeerContentProviderIds: process.env.REACT_APP_MEDINEER_CONTENTCURATORIDS?.split(',')?.map(id => Number(id)),
    razorPayKey: process.env.REACT_APP_RAZORPAY_KEY,
    pulseMatrixPassCriteria: 3,
    UserDefaultPassword: 'Welcome@1'
}; 